import React from 'react'
import { Chip, Typography } from '@mui/material'
import { Box } from '@mui/system'
import PropTypes from 'prop-types'

import { XMarkIcon } from '~/assets/icons'

// Dùng chung ở nhiều màn.
const HeaderTable = ({ onGoBack, name = '', colorText = '#000', orderCode }) => {
  const renderGoback = () => {
    if (typeof onGoBack !== 'function') return <Box />

    return (
      <Typography lineHeight="0" onClick={onGoBack}>
        <XMarkIcon size="18" color={colorText} />
      </Typography>
    )
  }

  const renderOrderCode = () => {
    if (!orderCode) return null

    return (
      <Box color={colorText} fontWeight="600" fontSize="2rem" paddingTop="4px">
        {orderCode}
      </Box>
    )
  }

  return (
    <Box
      padding="12px 0"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      bgcolor={'baseColor.color1'}>
      <Box display="flex" alignItems="center" columnGap={4}>
        {renderGoback()}
        {renderOrderCode()}
      </Box>
      {name && (
        <Chip
          sx={{
            border: `1px solid ${colorText}`,
            alignItems: 'center',
            padding: '10px 4px',
            minWidth: '100px',
            fontWeight: 500,
            color: colorText,
            backgroundColor: 'transparent',
          }}
          label={name}
        />
      )}
    </Box>
  )
}

export default React.memo(HeaderTable)

HeaderTable.propTypes = {
  onGoBack: PropTypes.func,
  name: PropTypes.string.isRequired,
  colorText: PropTypes.string,
  orderCode: PropTypes.string,
}
